

import profileEdit from '../Images/contact.jpg'
import edit from '../Images/edit.png'
import './profile.css'
import gift from '../Images/gift.png'
import config from "../config.json";
import add from '../Images/add.png'
import person from '../Images/person.png'
import mobile from '../Images/mobile.png'
import instagram from '../Images/instagram3.png'
import telegram from '../Images/telegram3.png'
import pernsil from '../Images/pernsil.png'
import delete1 from '../Images/delete.png'

import whatsapp from '../Images/whatsapp3.png'
import Eitaa from '../Images/Eitaa3.png'
import bale from '../Images/bale3.png'

import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import horzintalLine from '../Images/horzintalLine.png'
import { toast } from "react-toastify";

export default function Main() {
    let navigate = useNavigate();


    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        //GetUserInfo()
        getProfile();
    }, []);

    const formRef = useRef({});
    const [form, setForm] = useState({})
    /*
    const [userInfo, setUserInfo] = useState({})
    const [isLoadingUser, setIsLoadingUser] = useState(false);
    const GetUserInfo = async () => {
        setIsLoadingUser(true);
        await Services.GetUserInfo()
            .then(({ data }) => {
                setIsLoadingUser(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setUserInfo(data.payload);
            })
            .catch(err => {
                setIsLoadingUser(false);
            });
    }*/
    const [isLoading, setIsLoading] = useState(false);
    const getProfile = async (e) => {
        setIsLoading(true);
        await Services.getProfile()
            .then(async ({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setForm(data.payload);
                setPreviewImge(`${config.apiUrl}/pic/${data.payload.id}.jpg?${new Date().getTime()}`);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }

    const upload = (e, background, name) => {
        const { files } = e.target;
        if (files.length === 0) {
            return;
        }
        if (background) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                //style={{ backgroundImage: `url(${travelDetailPic})` }}            
                background.current.style.backgroundImage = `url(${fileReader.result})`;
            };
            fileReader.readAsDataURL(files[0]);
        }
        setForm({ ...form, [name]: e.target.files[0] })
    }




    const [isPosting, setIsPosting] = useState(false);
    const doPost = async (e) => {
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        console.log(form);
        setIsPosting(true);
        await Services.ChangeProfile(form)
            .then(async ({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                toast.dark('انجام شد');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    const [previewImge, setPreviewImge] = useState(null);
    const picRef = useRef(null);

    return (
        <>
            <div className='row mt-5'>
                <div className='col'>
                    {isLoading &&
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    }
                </div>
            </div>
            <form ref={formRef} className=" needs-validation">
                <div className='row p-1 '>
                    <div className='col d-flex  align-items-center  justify-content-center '>
                        <div>
                            <input
                                type="file"
                                className='d-none'
                                ref={picRef}
                                accept="image/*"
                                onChange={(e) => {
                                    upload(e, null, "pic");
                                    setPreviewImge(URL.createObjectURL(e.target.files[0]));
                                }}
                            />
                            <img
                                src={previewImge ? previewImge : profileEdit}
                                className=''
                                id="picProfile"
                                onLoad={() => { setForm({ ...form, file: picRef.current.files[0] }) }}
                                onError={() => { setPreviewImge(null) }}
                            />
                            <Link to="/"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    picRef?.current?.click();
                                }} >
                                <img
                                    src={edit}
                                    className=''
                                    id="editPencil" />
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="row mt-3 p-0">
                    <div className='col p-0 d-flex justify-content-center'>
                        <img src={horzintalLine} />
                    </div>
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={person}
                            className=" " />
                    </div>
                    <input
                        asp-for="name"
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="نام و نام خانوادگی"
                        required
                        autoComplete="off" />
                    <span
                        asp-validation-for="name"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={mobile}
                            className=" " />
                    </div>
                    <input
                        asp-for="mobile"
                        type="number"
                        name="mobile"
                        value={form.mobile}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="شماره موبایل"
                        required
                        autoComplete="off" />
                    <span
                        asp-validation-for="mobile"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={instagram}
                            className=" " />
                    </div>
                    <input
                        asp-for="instagram"
                        type="text"
                        name="instagram"
                        value={form.instagram}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="آی دی اینستاگرام ( اختیاری )"
                        autoComplete="off" />
                    <span
                        asp-validation-for="instagram"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={telegram}
                            className=" " />
                    </div>
                    <input
                        asp-for="telegram"
                        type="text"
                        name="telegram"
                        value={form.telegram}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="آی دی تلگرام ( اختیاری )"
                        autoComplete="off" />
                    <span
                        asp-validation-for="telegram"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={whatsapp}
                            className=" " />
                    </div>
                    <input
                        asp-for="whatsapp"
                        type="text"
                        name="whatsapp"
                        value={form.whatsapp}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="واتس آپ"
                        autoComplete="off" />
                    <span
                        asp-validation-for="whatsapp"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={bale}
                            className=" " />
                    </div>
                    <input
                        asp-for="baleh"
                        type="text"
                        name="baleh"
                        value={form.baleh}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="بله"
                        autoComplete="off" />
                    <span
                        asp-validation-for="baleh"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={Eitaa}
                            className=" " />
                    </div>
                    <input
                        asp-for="eita"
                        type="text"
                        name="eita"
                        value={form.eita}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="ایتا"
                        autoComplete="off" />
                    <span
                        asp-validation-for="eita"
                        className="text-danger" />
                </div>
                <div className="form-check mt-4 mb-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        value={form.showData}
                        name="showData"
                        onChange={(e) => {
                            setForm({ ...form, showData: e.target.checked ? true : false });
                        }}
                        checked={form.showData == true}
                    />
                    <label className="form-check-label text-white" htmlFor="checkIndeterminate">
                        شماره تماس نمایش داده شود.
                    </label>
                </div>

                <div className='row'>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn1 py-3"
                            onClick={doPost}
                            disabled={isPosting}>
                            <img src={add} className="me-2" /> ثبت
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </button>
                    </div>

                </div>
            </form>
            <div className="row mt-4">
                <div className="col d-flex justify-content-center">
                    <span className="text-white">  </span>
                    <Link
                        className="textColor1 text-decoration-none ms-1"
                        to="/"> لیست بارکدها</Link>
                </div>
            </div>
        </>

    );

}
